import { render, staticRenderFns } from "./NavigationBacklink.vue?vue&type=template&id=1d7152d0&"
import script from "./NavigationBacklink.vue?vue&type=script&lang=js&"
export * from "./NavigationBacklink.vue?vue&type=script&lang=js&"
import style0 from "./NavigationBacklink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports